import React from 'react';
import '../../components/css/popupstyle.css';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import $ from 'jquery';
import { userService } from '../../_services/user.service';
import loader from '../../components/css/dark/img/loader.gif';

class WholesalerCommissionReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            btnLoader: false,
            error: '',
            columnData: []
        }
        this.reportData = this.reportData.bind(this);
        this.reportData_new = this.reportData_new.bind(this);
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                paramsName: JSON.parse(localStorage.getItem('user')).paramsname,
                userdata: JSON.parse(localStorage.getItem('user')),
                MonthList: []
            };
        }
        catch (error) { }
    }
    componentDidMount() {
        this.GetCommission_Separate(this.state.userdata.wholesaler, this.state.userdata.wholesaler_Id, '');
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    GetCommission_Separate(whname, wholesaler_Id, mname) {

        this.setState({ loader: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ whname, wholesaler_Id, mname })
        };
        return fetch(`/api/ws/wh_commission_type`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        this.setState({ MonthList: apidata[0]["monthList"], loader: false, error: '' });
                    } else {
                        this.setState({ loader: false, error: 'Data not found' });
                    }
                }
                catch (error) {
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    reportData(e) {
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            let month_year = $("#commissionSelect").val();
            let paramsName = this.state.paramsName;
            let wh_id = this.state.userdata.wholesaler_Id;
            let unique_ObjectId = this.state.userdata.unique_ObjectId;
            let End_Point = "/report/payout_report_Wholesaler_OWN";
            if (wh_id == 61) {
                End_Point = "/report/payout_report_Wholesaler_OWN";
            }
            window.open(
                Origin_Location + End_Point + '?&name=' + paramsName + '&wh_id=' + wh_id + '&csvfor=ds&m=' + month_year + '&processor=0&ObjectId=' + unique_ObjectId,
                '_blank'
            );
            //this.reportData_new(paramsName, wh_id, "ds", month_year, "0");
            //this.ExportWidget(e);
            e.preventDefault();
        }
        catch (error) { }
    }
    handleFocus = () => {
        $('#commissionSelect').prop('size', 10);
    }
    handleBlur = () => {
        $('#commissionSelect').prop('size', 1);
    }
    reportData_new(name, wh_id, csvfor, m, processor) {
        var wh_payout = false;
        this.setState({ btnLoader: true });
        var landing_url = window.location.origin;
        if ((landing_url == 'https://staging.glichealth.com' || landing_url == 'https://reporting.glichealth.com') && wh_id == 189) {
            wh_payout = true;
        }
        else if ((landing_url == 'https://dev.glichealth.com' || landing_url == 'https://tempfilter-dev.glichealth.com' || landing_url == 'http://localhost:5464') && wh_id == 195) {
            wh_payout = true;
        }
        else {
            wh_payout = false;
        }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ name, wh_id, csvfor, m, processor })
        };
        return fetch(`/api/CommissionReport/reportData_new`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        try {
                            var tableData = [];
                            if (wh_id == 61) {
                                var headingData = [];
                                headingData.push("RecipientCompanyAssignedUniqueKey(primary group)");
                                headingData.push("Additional groups");
                                headingData.push("First Name");
                                headingData.push("Last Name");
                                headingData.push("RecipientNotificationEmailAddress");
                                headingData.push("Earned Commission");
                                headingData.push("Commission for Sub Distributor");
                                headingData.push("Commission Due to Distributor");
                                if (apidata[0].isBonusAllowed) {
                                    headingData.push("Bonus Commission Earned");
                                }
                                headingData.push("Actual Earned Commission");
                                if (wh_payout == true)
                                    headingData.push("Wholesaler Payout");
                            }
                            else {
                                var headingData = [];
                                headingData.push("Primary Group Number");
                                headingData.push("Additional Group Numbers");
                                headingData.push("First Name");
                                headingData.push("Last Name");
                                headingData.push("Email Address");
                                headingData.push("Direct Commission Earned");
                                // headingData.push("Override Commission Generated");
                                headingData.push("Commissions on Referrals");//headingData.push("Override Commission Earned");
                                if (apidata[0].isBonusAllowed) {
                                    headingData.push("Bonus Commission Earned");
                                }
                                headingData.push("Total Commission Earned");
                                if (wh_payout == true)
                                    headingData.push("Wholesaler Payout");
                            }
                            tableData.push(headingData.join(","));
                            var data = "";
                            for (var i = 0; i < apidata.length; i++) {
                                var rowData = [];
                                try {
                                    rowData.push(apidata[i].recipientCompanyAssignedUniqueKey);
                                    rowData.push(apidata[i].additionalgroups.replace(/,/g, "-"));
                                    rowData.push(apidata[i].firstName);
                                    rowData.push(apidata[i].lastName);
                                    rowData.push(apidata[i].recipientNotificationEmailAddress);
                                    rowData.push(apidata[i].earned_Commission);
                                    if (wh_id == 61) {
                                        rowData.push(apidata[i].commission_for_subdis);
                                    }
                                    rowData.push(apidata[i].commission_due_to_subdis);
                                    if (apidata[i].hasOwnProperty('user_Bonus') && apidata[i].isBonusAllowed) {
                                        rowData.push(apidata[i].user_Bonus);
                                    }
                                    rowData.push(apidata[i].total_Earned);
                                    if (wh_payout == true)
                                        rowData.push(apidata[i].wholesaler_Payout);
                                }
                                catch (error) {
                                    rowData.push("");
                                }
                                //rowData1 = rowData.join('');
                                tableData.push(rowData.join(","));
                            }
                            data += tableData.join("\n");
                            if (window.navigator.msSaveOrOpenBlob) {
                                // IE11
                                window.navigator.msSaveOrOpenBlob(new Blob([data]), "Commission_Payout_Report" + "_" + m + ".csv");
                                this.setState({ btnLoader: false });
                            } else {
                                $(document.body).append('<a id="download-link" download="' + "Commission_Payout_Report" + "_" + m + ".csv" + '" href=' + URL.createObjectURL(new Blob([data], { type: "text/csv" })) + '/>');
                                this.setState({ btnLoader: false });
                            }
                            $('#download-link')[0].click();
                            $('#download-link').remove();
                        } catch (error) {
                        }
                    }
                    else {
                        var tableData = [];
                        var headingData = [];
                        headingData.push("Primary Group Number");
                        headingData.push("Additional Group Numbers");
                        headingData.push("First Name");
                        headingData.push("Last Name");
                        headingData.push("Email Address");
                        headingData.push("Direct Commission Earned");
                        headingData.push("Commissions on Referrals");//headingData.push("Commission for Sub Distributor");
                        headingData.push("Total Commission Earned");
                        tableData.push(headingData.join(","));
                        var data = "";
                        data += tableData.join("\n");
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(new Blob([data]), "Commission_Payout_Report" + "_" + m + ".csv");
                        } else {
                            $(document.body).append('<a id="download-link" download="' + "Commission_Payout_Report" + "_" + m + ".csv" + '" href=' + URL.createObjectURL(new Blob([data], { type: "text/csv" })) + '/>');
                        }
                        $('#download-link')[0].click();
                        $('#download-link').remove();
                        this.setState({ btnLoader: false });
                    }
                }
                catch (error) {
                    this.setState({ btnLoader: false });
                }
            });
    }
    render() {
        const { loader, error, btnLoader } = this.state;
        return (

            <div className='popup mfp-zoom-in report-section commission-edit popup-right-radius'>
                <div className='popup_inner'>

                    <h1>{this.props.text}<button onClick={this.props.closeCommissionPopup}>X</button></h1>
                    {
                        loader ? <div className="theme-loader commissionLoader"></div> : null
                    }
                    {
                        this.state.MonthList.length ?
                            <div id="dashboard_header" className="big_dash_header">
                                <div className="dashboard-icons">

                                    <DashboardHeaderIcons />

                                </div>
                                <div id="dashboard_header_inner">
                                    <div id="dashboard-back-button"></div>
                                    <div id="dashboard_header_select">
                                        <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                            <div className="selectSection payout">
                                                <label>Select Month, Year</label>
                                                <span className="down-arrow"></span>
                                                <select className="form-Control" id="commissionSelect" onChange={this.handleOnChange} value={this.state.value} >
                                                    {
                                                        this.state.MonthList != null ?
                                                            this.state.MonthList.map((obj, index) => {
                                                                return <option value={obj.monthYearname}>{obj.monthYearname.replace(',', ', ')}</option>
                                                            }) : null
                                                    }
                                                </select>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="pop-btn ungap">
                                                {
                                                    btnLoader ? <div className="theme-loader commissionLoader btnLoader"></div> : null
                                                }
                                                <button className={btnLoader ? "btn btn-theme-color animated-btn" : "btn btn-theme-color"} onClick={this.reportData}>Download</button>
                                                <button className="btn cancel" onClick={this.props.closeCommissionPopup}>Cancel</button>
                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </div> :
                            <div>
                                {
                                    loader ?
                                        <div className="please-wait data-not-found"><h3>Please wait...</h3></div> :
                                        <span className="data-not-found">{error}</span>
                                }
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default WholesalerCommissionReport;
